/**
 * Chatbot Service
 * 
 * API client for the Mistral-powered chatbot endpoint.
 */

import api from './api';

/**
 * Send a question to the chatbot and get a response.
 * @param {string} message - The user's question
 * @returns {Promise<{response: string, success: boolean}>}
 */
export const askChatbot = async (message, history = []) => {
  const response = await api.post('/chatbot/ask/', { message, history });
  return response.data;
};

/**
 * Refine a text using AI.
 * @param {string} message - The text to rephrase
 * @returns {Promise<{response: string, success: boolean}>}
 */
export const rephraseReason = async (message) => {
  const response = await api.post('/chatbot/rephrase/', { message });
  return response.data;
};

/**
 * Drafts a bug report using AI based on rough text.
 * @param {string} message - The rough description
 * @returns {Promise<{response: Object, success: boolean}>}
 */
export const draftBugReport = async (message) => {
  const response = await api.post('/chatbot/bug-assistant/', { message });
  return response.data;
};

/**
 * Polishes a bug report field.
 * @param {string} message - The text to polish
 * @param {string} fieldType - 'title' or 'description'
 * @returns {Promise<{response: string, success: boolean}>}
 */
export const polishBugField = async (message, fieldType = 'description') => {
  const response = await api.post('/chatbot/bug-polish/', { message, field_type: fieldType });
  return response.data;
};

export default { askChatbot, rephraseReason, draftBugReport, polishBugField };
